export type CountdownTime = {
  totalTime: number;
  timestamps: number[];
};

export const getCountdownTime = (endTime: string): CountdownTime => {
  const totalTime = Date.parse(endTime) - Date.now();

  const days = Math.floor(totalTime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((totalTime / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((totalTime / 1000 / 60) % 60);
  const seconds = Math.floor((totalTime / 1000) % 60);

  return { totalTime, timestamps: [days, hours, minutes, seconds] };
};

export default getCountdownTime;
